export default "__VITE_ASSET__d59a9fce__"